import { Link, useLocation } from "react-router-dom";
import usePageMeta from "@/hooks/usePageMeta";

export default function NotFound() {
  const location = useLocation();
  usePageMeta({ title: "页面走丢了 - 香蕉动漫" });

  return (
    <div className="w-full px-4 md:px-6 py-20 flex flex-col items-center text-center">
      <span className="w-20 h-20 flex items-center justify-center rounded-full bg-primary-100 text-accent-700 text-4xl mb-6">
        <i className="ri-emotion-laugh-line"></i>
      </span>
      <h1 className="font-display font-black text-5xl md:text-7xl text-foreground-950">404</h1>
      <h2 className="mt-4 font-display font-bold text-xl md:text-2xl text-foreground-900">
        这个页面好像走丢了
      </h2>
      <p className="mt-3 text-sm text-foreground-500 font-mono">{location.pathname}</p>
      <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-md">
        你访问的页面不存在或已被移除，回到首页继续发现精彩的动漫内容吧。
      </p>
      <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 rounded-md bg-accent-500 px-5 py-2.5 text-sm font-bold text-white hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-home-4-line w-4 h-4 flex items-center justify-center"></i>
          返回首页
        </Link>
        <Link
          to="/search"
          className="inline-flex items-center gap-1.5 rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-800 hover:border-primary-300 transition-colors cursor-pointer whitespace-nowrap"
        >
          去搜索内容
        </Link>
      </div>
    </div>
  );
}